import React from 'react';

function ConspiracyThread(props){
    return (
        <line x1={props.x1} y1={props.y1} x2={props.x2} y2={props.y2} className="thread" filter="url(#thread-shadow)" />
    )
}
export default ConspiracyThread;


// WEBPACK FOOTER //
// ./src/components/ConspiracyThread.js